import { getContextAttributeNames } from '@gonfalon/openapi/operations/getContextAttributeNames';
import { getContextInstances } from '@gonfalon/openapi/operations/getContextInstances';
import { getContextInstanceSegmentsMembershipByEnv } from '@gonfalon/openapi/operations/getContextInstanceSegmentsMembershipByEnv';
import { searchContextInstances } from '@gonfalon/openapi/operations/searchContextInstances';

import { createQueryOptions } from '../internal/createQueryOptions';

export const searchContextInstancesQuery = createQueryOptions(searchContextInstances);
export const contextInstanceQuery = createQueryOptions(getContextInstances);
export const getContextInstanceSegmentMembershipQuery = createQueryOptions(getContextInstanceSegmentsMembershipByEnv);
export const getContextAttributeNamesQuery = createQueryOptions(getContextAttributeNames);
